import React from 'react'
import './Core_team.css'
import { Link } from 'react-router-dom'
import Common_title from '../../common/common-title/Common_title'

const Core_team = () => {
    return (
        <>
            <section className='Core_team_section margin_section'>
                <div className='container'>
                    <Common_title title="URBAN BUILD" subtitle="Our Team" />

                    <div className='row mt-5 justify-content-center'>
                        <div className='col-md-3 col-sm-6 col-9 mb-4'>
                            <div className='team_member_card'>
                                <div className='image_div_holder'>
                                    <div className='image_div'>
                                        <img className='memberimg' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/person1.png'} alt="Team Member 1" />
                                    </div>
                                    <div className='member_info'>
                                        <h6 className='name'>Vikram Desai</h6>
                                        <p className='position'>Tech Lead</p>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center icondiv'>
                                    <Link to={"https://www.facebook.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/facebook.png'} /></Link>
                                    <Link to={"https://x.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/twitter.png'} /></Link>
                                    <Link to={"https://www.instagram.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/instagram.png'} /></Link>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-3 col-sm-6 col-9 mb-4'>
                            <div className='team_member_card'>
                                <div className='image_div_holder'>
                                    <div className='image_div'>
                                        <img className='memberimg' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/person2.png'} alt="Team Member 1" />
                                    </div>
                                    <div className='member_info'>
                                        <h6 className='name'>Rahul Sharma</h6>
                                        <p className='position'>Founder & CEO</p>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center icondiv'>
                                    <Link to={"https://www.facebook.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/facebook.png'} /></Link>
                                    <Link to={"https://x.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/twitter.png'} /></Link>
                                    <Link to={"https://www.instagram.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/instagram.png'} /></Link>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-3 col-sm-6 col-9 mb-4'>
                            <div className='team_member_card'>
                                <div className='image_div_holder'>
                                    <div className='image_div'>
                                        <img className='memberimg' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/person3.png'} alt="Team Member 1" />
                                    </div>
                                    <div className='member_info'>
                                        <h6 className='name'>Priya Nair</h6>
                                        <p className='position'>Operations Head</p>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center icondiv'>
                                    <Link to={"https://www.facebook.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/facebook.png'} /></Link>
                                    <Link to={"https://x.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/twitter.png'} /></Link>
                                    <Link to={"https://www.instagram.com/"} target='_blank'><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/about/meet-team/instagram.png'} /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Core_team